import { render } from "./typePreViewFile.vue?vue&type=template&id=dc4ca5a0&scoped=true"
import script from "./typePreViewFile.vue?vue&type=script&lang=js"
export * from "./typePreViewFile.vue?vue&type=script&lang=js"

import "./typePreViewFile.vue?vue&type=style&index=0&id=dc4ca5a0&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4ca5a0"]])

export default __exports__